const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = (theme) => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2,
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 300,
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between",
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
  },
  button: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
    marginLeft: 213,
    minWidth: 85,
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: 15,
  },
  restoreButton: {
    padding: "0 !important",
  },
  tinyInfo: {
    fontSize: 12,
    fontStyle: 'italic'
  },
  summary: {
    padding: theme.spacing.unit
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: "block"
  },
  displayPref: {
    marginRight: theme.spacing.unit * 2,
    display: "block"
  },
  checkbox: {
    fontSize: "1.2em",
    fontWeight: "bold",
    display: "flex",
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2
  },
  checkboxLabel: {
    fontSize: "1.2em",
    fontWeight: "bold",
    display: "flex",
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2
  },
  nvp: {
    marginTop: "20px",
    marginRight: theme.spacing.unit,
    width: "100%"
  },

});

export default styles;
